<script setup>
import AppMenu from './AppMenuAdmin.vue';
</script>

<template>
    <app-menu></app-menu>
</template>

<style lang="scss" scoped></style>
